/** メール形式チェック */
export const validEmailFormat = (item: string) => {
  // eslint-disable-next-line operator-linebreak
  const regex =
    // eslint-disable-next-line no-useless-escape
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  return regex.test(item)
}
